import type { InboxV2Account } from "../types";

export function getInboxV2AccountDisplayName(account?: InboxV2Account) {
  return account?.login || account?.name || "account";
}
